<ng-container *ngIf="isRouted">
  <div class="routed-special-instructions">
    <span class="instructions-label">
      {{ 'i18n.confirmationPage.specialInstructions' | translate }}
    </span>
    <ng-container
      *ngTemplateOutlet="specialInstructionsTemplate"
    ></ng-container>
  </div>
</ng-container>
<ng-container *ngIf="isVendorShip">
  <div class="vendor-ship-special-instructions">
    <span class="instructions-label">
      {{ 'i18n.confirmationPage.additionalDeliveryInstructions' | translate }}:
    </span>
    <ng-container
      *ngTemplateOutlet="specialInstructionsTemplate"
    ></ng-container>
  </div>
</ng-container>

<ng-template #specialInstructionsTemplate>
  <span class="instructions-content none" *ngIf="isWithoutSpecialInstructions">
    {{ 'i18n.confirmationPage.none' | translate }}
  </span>
  <span class="instructions-content special" *ngIf="isWithSpecialInstructions">
    {{ order?.orderHeader?.specialDeliveryInstructions }}
  </span>
</ng-template>
